import {
  isNumeric,
  isValidCompanyDomain,
  isValidCompanyLinkedInUrl,
  isValidEmail,
  isValidPeopleLinkedInUrl,
  isValidPhoneNumber,
  isValidUrl,
} from '@aibees/shared/utils';
import { FieldValidationType } from '../../types';

export function hasInvalidValues(
  values: string[],
  validation: FieldValidationType
) {
  if (validation === FieldValidationType.PHONE)
    return values.some((x) => !isValidPhoneNumber(x));
  if (validation === FieldValidationType.URL)
    return values.some((x) => !isValidUrl(x));
  if (validation === FieldValidationType.EMAIL)
    return values.some((x) => !isValidEmail(x));
  if (validation === FieldValidationType.NUMBER)
    return values.some((x) => !isNumeric(x));
  if (validation === FieldValidationType.COMPANY_LINKEDIN_URL)
    return values.some((x) => !isValidCompanyLinkedInUrl(x));
  if (validation === FieldValidationType.PEOPLE_LINKEDIN_URL)
    return values.some((x) => !isValidPeopleLinkedInUrl(x));
  if (validation === FieldValidationType.COMPANY_DOMAIN)
    return values.some((x) => !isValidCompanyDomain(x));

  return false;
}
